import React, { useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import axios from "axios";

function Addnoticeboard() {
  // const [image, setimage] = useState();
  const [noticeboardtitle, setnoticeboardtitle] = useState(" ");
  const [noticeboarddate, setnoticeboarddate] = useState();
  const [noticeboardclassname, setnoticeboardclassname] = useState(" ");
  const [noticeboardsubject, setnoticeboardsubject] = useState(" ");
  const [noticeboardcontent, setnoticeboardcontent] = useState(" ");

  const formdata = new FormData();

  const postimage = async () => {
    //formdata.append("noticeboardfile", image);
    formdata.append("noticeboardtitle", noticeboardtitle);
    formdata.append("noticeboardclassname", noticeboardclassname);
    formdata.append("noticeboarddate", noticeboarddate);
    formdata.append("noticeboardsubject", noticeboardsubject);
    formdata.append("noticeboardcontent", noticeboardcontent);
    formdata.append("type", noticeboardcontent);

    try {
      const config = {
        url: "/addnoticeboard",
        method: "post",
        baseURL: "/api",
        headers: { "noticeboard-type": "multipart/form-data" },
        data: formdata,
        //responseType:"application/json"
      };
      let res = await axios(config);
      if (res.status === 200) {
        console.log(res.data);
        alert("noticeboard add successfully");
        window.location.assign("/admin/noticeboard");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div className="container mt-5">
      <Card
        className="text-center"
        style={{
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        }}
      >
        <h5 className="pt-5">Create Noticeboard for All</h5>
        <Card.Body>
          <Form className="w-50 mx-auto">
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Title</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter title"
                onChange={(e) => setnoticeboardtitle(e.target.value)}
              />
              {/* <Form.Text className="text-muted">
                We'll never share your email with anyone else.
              </Form.Text> */}
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Content</Form.Label>
              <Form.Control
                type="text"
                placeholder="Content"
                row="2"
                onChange={(e) => setnoticeboardcontent(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Date</Form.Label>
              <Form.Control
                type="date"
                placeholder="Date"
                onChange={(e) => setnoticeboarddate(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Subject</Form.Label>
              <Form.Control
                type="text"
                placeholder="Subject"
                onChange={(e) => setnoticeboardsubject(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>classname</Form.Label>
              <Form.Control
                type="text"
                placeholder="Date"
                onChange={(e) => setnoticeboardclassname(e.target.value)}
              />
            </Form.Group>
          </Form>

          <button className="btn btn-primary" onClick={postimage}>
            Create Noticeboard
          </button>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Addnoticeboard;
